// extracted by mini-css-extract-plugin
export default {"reply":"Reply_reply__EJuLE","reply-img":"Reply_reply-img__8HH9R","mar":"Reply_mar__+Mf83","btn":"Reply_btn__-Jxm5"};